<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main.vue'
import Header from '@components/header.vue'
import { store } from '../../state/store'
import TableBody from '@components/scrolling-table-body.vue'
import EventHistoryService from '@services/business/event-history.service'
import moment from 'moment'

const ROWS_TO_LOAD = 25

export default {
  page: {
    title: 'Event History',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, Header, TableBody },
  data() {
    return {
      state: store.state,
      isLoading: false,
      columns: {
        Date: {
          value: 'Date',
          style: 'width: 5em',
        },
        Zone: {
          value: 'Zone',
          style: 'width: 5em',
        },
        Event: {
          value: 'Event',
          style: '',
        },
        Comment: {
          value: 'Comment',
          style: '',
        },
      },
      rows: [],
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.rows = []
      this.isLoading = true
      EventHistoryService.getNinetyDayEventHistory().then(() => {
        this.loadEvents()
        this.isLoading = false
      })
    },
    loadEvents() {
      var length = this.rows.length

      for (
        var i = length;
        i < length + ROWS_TO_LOAD &&
        i < this.state.ninetyDayEventHistory.length;
        i++
      ) {
        var event = this.state.ninetyDayEventHistory[i]
        var row = {
          Date: {
            value: moment(new Date(event.eventDate)).format('MM/DD/YY hh:mm'),
            style: 'width: 5em',
          },
          Zone: {
            value: event.zoneId,
            style: 'width: 5em',
          },
          Event: {
            value: event.eventDescription,
            style: '',
          },
          Comment: {
            value: event.comment,
            style: '',
          },
        }
        this.rows.push(row)
      }

      return this.rows.length < this.state.ninetyDayEventHistory.length
    },
  },
}
</script>

<template>
  <Layout>
    <Header />
    <div :class="$style.event_history_parent_container">
      <div>
        <div v-show="isLoading" :class="$style.spinner_container">
          <div class="spinner"></div>
        </div>
        <div v-show="!isLoading">
          <div :class="$style.event_history_header_container">
            <h1 :class="$style.event_history">Event History</h1>
            <h4 class="small u-text--caps text-muted">Past 90 Days</h4>
            <span :class="$style.refresh_button_container">
              <button :class="$style.refresh_button" @click="init">
                <img
                  :class="$style.refresh_image"
                  src="@src/assets/images/Refresh_icon.svg#refresh"
                />
              </button>
            </span>
          </div>

          <div :class="$style.event_history_table_container">
            <table :class="$style.fixed_table_header">
              <thead :class="$style.table_header">
                <tr>
                  <th
                    v-for="column in columns"
                    :key="column.value"
                    :value="column.value"
                    :class="$style.table_header_column"
                    :style="column.style"
                  >
                    {{ column.value }}
                  </th>
                </tr>
              </thead>
            </table>
            <TableBody
              :rows="rows"
              :is-infinitely-scrolling="true"
              :callback="loadEvents"
            ></TableBody>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.event_history_parent_container {
  text-align: center;
  position: relative;
  top: $height-status-bar;
  padding: 0 0.25em;
}

.event_history_header_container {
  position: fixed;
  width: 100%;
  text-align: center;
  z-index: 4;
  background: $color-body-bg;
  height: $height-event-history-header;
}

.event_history {
  margin-top: 0.5em;
  font-weight: 900;
  color: $color-text-primary;
  line-height: 1.875rem;
  margin-bottom: 0.25em;
}

.event_history_subheader {
  color: $color-text-secondary;
}

.refresh_button_container {
  right: 1em;
  background: $color-body-bg;
  position: absolute;
  bottom: 1em;
  z-index: 2000;
}

.refresh_button {
  float: right;
  background-color: transparent;
  border: 0;
  color: $color-text-primary;
  cursor: pointer;
  font-size: 1em;
}

.refresh_image {
  width: 2em;
}

.event_history_table_container {
  position: relative;
  top: $height-event-history-header;
}

.fixed_table_header {
  table-layout: fixed;
  width: 100%;
  position: sticky;
  z-index: 3;
  background: $color-body-bg;
  height: $height-table-header;
  color: $color-text-primary;
  text-align: center;
  top: $height-status-bar + $height-navbar + $height-event-history-header;
}

.table_column {
  word-wrap: break-word;
}

.spinner_container {
  position: fixed;
  top: 0;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
}

.spinner {
  display: flex;
  margin: 0 auto;
}
</style>
